module.exports = __webpack_public_path__ + "img/scene4@2x.fb715a32.png";